const prev = document.querySelector("#prev");
const next = document.querySelector("#next");

let carouselVp = document.querySelector("#carousel-vp");
let cCarouselInner = document.querySelector("#cCarousel-inner");
let windowWidth = window.innerWidth;
let carouselInnerWidth = cCarouselInner.getBoundingClientRect().width;
let leftValue = 0;

// Variable used to set the carousel movement value (card's width + gap)
const totalMovementSize =
  parseFloat(
    document.querySelector(".cCarousel-item").getBoundingClientRect().width,
    10
  ) +
  parseFloat(
    window.getComputedStyle(cCarouselInner).getPropertyValue("gap"),
    10
  );

const totalCards = document.querySelectorAll(".cCarousel-item").length;
const visibleCards = Math.floor(
  carouselVp.getBoundingClientRect().width / totalMovementSize
);
const maxLeftValue = -(totalMovementSize * (totalCards - visibleCards));

prev.addEventListener("click", () => {
  if (leftValue < 0) {
    leftValue += totalMovementSize;
    cCarouselInner.style.left = leftValue + "px";
  }
});

next.addEventListener("click", () => {
  const carouselVpWidth = carouselVp.getBoundingClientRect().width;
  const remainingWidth = carouselInnerWidth - Math.abs(leftValue);

  if (remainingWidth > carouselVpWidth) {
    leftValue -= totalMovementSize;
    if (leftValue < maxLeftValue) {
      leftValue = maxLeftValue;
    }
    cCarouselInner.style.left = leftValue + "px";
  }
});

const mediaQuery510 = window.matchMedia("(max-width: 510px)");
const mediaQuery770 = window.matchMedia("(max-width: 770px)");
const mediaQuery1024 = window.matchMedia("(min-width: 1024px)");

mediaQuery510.addEventListener("change", mediaManagement);
mediaQuery770.addEventListener("change", mediaManagement);
mediaQuery1024.addEventListener("change", mediaManagement);

let oldViewportWidth = window.innerWidth;

function mediaManagement() {
  const newViewportWidth = window.innerWidth;

  if (leftValue <= -totalMovementSize && oldViewportWidth < newViewportWidth) {
    leftValue += totalMovementSize;
    cCarouselInner.style.left = leftValue + "px";
    oldViewportWidth = newViewportWidth;
  } else if (
    leftValue <= -totalMovementSize &&
    oldViewportWidth > newViewportWidth
  ) {
    leftValue -= totalMovementSize;
    cCarouselInner.style.left = leftValue + "px";
    oldViewportWidth = newViewportWidth;
  }
}
